import{b as v}from"./ninox-components-DBZCHTU6.js";import{m as u}from"./ninox-components-2ADN25D5.js";import{f as b}from"./ninox-components-DFJEWGV6.js";import{f as h}from"./ninox-components-MYF6AQNE.js";import g from"styled-components";var z=g.div`
    position: absolute;
    background: inherit;

    --_tip-gap: clamp(2 * var(--tip-size), var(--tip-gap), calc(100% - 2 * var(--tip-size)));

    ${({verticalAlign:t,horizontalAlign:a})=>{let l="auto",p="auto",s="auto",n="auto",o="translate(-50%, 0)",r="var(--tip-size)",i="calc(2 * var(--tip-size))",e="polygon(0 100%, 50% 0, 100% 100%)";switch(a){default:case"stretch":case"left":case"center":s="var(--_tip-gap)";break;case"right":n="var(--_tip-gap)",o="translate(50%, 0)";break}switch(t){default:case"bottom":l="calc(-1 * var(--tip-size))";break;case"stretch":case"center":l="var(--_tip-gap)",o="translate(0, -50%)",i="var(--tip-size)",r="calc(2 * var(--tip-size))",a==="left"?(s="auto",n="calc(-1 * var(--tip-size))",e="polygon(0 0, 0 100%, 100% 50%)"):(s="calc(-1 * var(--tip-size))",n="auto",e="polygon(100% 0, 100% 100%, 0 50%)");break;case"top":p="calc(-1 * var(--tip-size))",e="polygon(0 0, 100% 0, 50% 100%)";break}return{clipPath:e,top:l,bottom:p,left:s,right:n,transform:o,width:i,height:r}}}
`,k=g.aside`
    position: absolute;
    inset: 0;
    z-index: -1;
    isolation: isolate;

    background-color: ${({theme:t})=>t.popup.backgroundColor};
    border-radius: inherit;
    transform: translateZ(0);

    filter: ${({theme:t,level:a})=>a&&`drop-shadow(${v.d0(t.popup.borderColor)}) drop-shadow(${v[a]()})`};
`,$=g.div`
    position: absolute;
    inset: auto;
    z-index: 1;

    display: flex;
    flex-direction: column;
    box-sizing: border-box;

    max-width: 100vw;
    max-height: 100vh;

    margin: 0;
    padding: 0;

    color: ${({theme:t})=>t.popup.color};
    background-color: transparent;

    border-radius: ${b.large};
    border: none;

    overflow: unset;

    --tip-size: ${u.x_small};
    --tip-gap: ${u.large};

    &:focus-visible {
        outline-width: ${h.tiny};
        outline-style: solid;
        outline-color: ${({theme:t})=>t.grid.secondary};
    }

    --tip-size: ${({withTip:t})=>!t&&0};

    ${({verticalAlign:t,horizontalAlign:a})=>{let l="0",p="0",s="",n="",o="0",r="0",i="0",e="0",c="none",d;switch(a){case"stretch":i="0",e="auto",s="100%";break;case"left":i="0",e="auto";break;case"center":i="50%",e="auto",d="50%",c="translate(-50%, 0)";break;case"right":i="auto",e="0";break}switch(t){case"top":o="auto",r="100%",p="calc(-1 * var(--tip-size))";break;case"stretch":o="50%",r="auto",d="50%",n="100%";break;case"center":o="50%",r="auto",d="50%",a==="center"?c="translate(-50%, -50%)":a==="left"?(c="translate(-100%, -50%)",l="calc(-1 * var(--tip-size))",i="calc(-1 * var(--tip-size))",e="auto"):(c="translate(100%, -50%)",l="var(--tip-size)",i="auto",e="calc(-1 * var(--tip-size))");break;case"bottom":o="100%",r="auto",p="var(--tip-size)";break}return{marginLeft:l,marginTop:p,minWidth:s,minHeight:n,top:o,bottom:r,left:i,right:e,transform:c,"--tip-gap":d}}};

    transition-timing-function: ease;
    transition-duration: 200ms;
    transition-property: opacity, visibility, overlay;

    visibility: hidden;
    opacity: 0;
    overlay: none;

    &[aria-hidden='false'] {
        visibility: visible;
        opacity: 1;
        overlay: auto;
    }
    &:popover-open {
        visibility: visible;
        opacity: 1;
        overlay: auto;
    }
`;export{z as a,k as b,$ as c};
//# sourceMappingURL=ninox-components-VNU6XGBU.js.map